/**
 * Media-ID handling for image upload fields. The tours API stores media IDs
 * (e.g. `featuredImageId`, validated as UUIDs) rather than URLs, and serves
 * images at `/api/v1/media/:id` — while the shared upload dropzone defaults to
 * storing the uploaded file's URL.
 */
export const getMediaIdFromResponse = (data: Record<string, unknown>) => data.id as string;

export const getMediaPreviewUrl = (mediaId: string) => `/api/v1/media/${mediaId}`;

/**
 * Spread into a CrudConfig `type: 'image'` field so uploads store the media ID
 * (not the URL) and existing IDs preview correctly.
 */
export const mediaIdImageField = {
  getImageValueFromResponse: getMediaIdFromResponse,
  getImagePreviewUrl: getMediaPreviewUrl,
} as const;
